/* eslint-disable import/no-unresolved */
import React from 'react';

import enterpriseSVG from 'assets/resources/icon/enterprise.svg';
import saassSVG from 'assets/resources/icon/saas.svg';
import b2cv1SVG from 'assets/resources/icon/b2c_v1.svg';
import b2cv2SVG from 'assets/resources/icon/b2c_v2.svg';

import Layout from '../../components/Layout';
import PartialsHeader from '../../components/Partials/PartialsHeader';
import PartialsQuestion from '../../components/Partials/PartialsQuestion';
import ResultsCardSwiperSection from '../../components/ResultsCardSwiperSection';
import IndustriesScrum from '../../components/Industries/IndustriesScrum';
import IndustriesCTA from '../../components/Industries/IndustriesCTA';
import IndustriesSingleItem from '../../components/Industries/IndustriesSingleItem';

const BUSINESS_LIST = [
  {
    icon: enterpriseSVG,
    title: 'Enterprise and industry systems',
    list: [
      'CRM Customer Relations Management',
      'ERP Enterprise Resource Planning',
      'OSS and BSS'
    ]
  },
  {
    icon: saassSVG,
    title: 'SaaS (Software as a service) platforms',
    list: [
      'Real time applications',
      'Marketplace',
      'White label and Multi tenancy software',
      'Price calculations'
    ]
  },
  {
    icon: b2cv1SVG,
    title: 'B2C portals and websites',
    list: ['Customer management', 'Order processing', 'Secure payments']
  },
  {
    icon: b2cv2SVG,
    title: 'B2B portals and websites',
    list: ['Marketplace', 'Reporting tool', 'Work and document management']
  }
];

const telecommunication = () => {
  return (
    <Layout
      title="Software services for telecommunication | Ulam Labs"
      description="Telecommunication companies need a realiable software. Our team has expertise in creating a custom CRM or a real-time marketplace with secure payments for telco."
    >
      <PartialsHeader>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title">Telecommunication</h1>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <div className="telecommunication text-format">
        <IndustriesCTA
          title=""
          extra="From the very first days, Ulam Labs has been supporting the
              telecommunications industry by delivering cutting edge software."
        />
        <div className="container">
          <div className="softwares">
            <div className="row">
              <div className="col-lg-8 col-md-12 col-md-auto">
                <div className="subtitle bigger without">
                  Software that serves your needs
                  <div className="extra">
                    We turn your ideas into software. Whether you are looking
                    for help in creating a custom CRM or a real-time marketplace
                    with secure payments, our team at Ulam Labs can share their
                    expertise. See the scope of projects in which we can help
                    you.
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-md-12">
                <div className="left-beam">
                  <div className="icon-beam horizontal">
                    <div className="row">
                      {BUSINESS_LIST.map(item => (
                        <IndustriesSingleItem item={item} key={item.title} />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <IndustriesScrum />
            </div>
          </div>
        </div>
        <ResultsCardSwiperSection
          title="See related projects"
          buttonsAround={false}
          className="basis-slider"
          category="TELCO"
        />
      </div>
      <PartialsQuestion />
    </Layout>
  );
};

export default telecommunication;
